<template>

   <div class="container">
       <div class="title text-center">Réservez une démo de nos outils</div>
       
       <iframe src="https://koalendar.com/e/presentation-digitappro-avec-nicolas?embed=true" style="border:0px #ffffff none;"   name="koalendar-iframe" scrolling="no" frameborder="1" marginheight="0px" marginwidth="0px" width="100%" allowfullscreen="" height="800px"></iframe>
       
       <div class="row">
           <div class="col-md-2 mx-auto"><img src="../assets/img/DigitAppro.png" class="img-fluid" alt="DigitAppro"></div>
           <div class="col-md-2 mx-auto"><img src="../assets/img/Fleet.png"  class="img-fluid" alt="Fleet"></div>
           <div class="col-md-2 mx-auto"><img src="../assets/img/BourseEchange.png" class="img-fluid" alt="Bourse d'Echange"></div>
       </div>



<!-- Modal -->
<div class="modal fade" ref="confmodal"  tabindex="-1"  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        ...
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>


       <div class="terms">
          Les informations recueillies sur ce formulaire vous permettent de recevoir des communications sur nos offres, produits et services ; de répondre à vos demandes de démonstration de nos services et plus largement d’opérer notre mise en contact mutuelle. La fourniture de votre email est nécessaire pour recevoir les communications susmentionnées mais demeure entièrement facultative.
          La base légale est le consentement ( art. 6.1.a du RGPD). Les destinataires de données sont le responsable de traitement(SAS AgriVitech, RCS Reims 882 706 658) , ses services internes en charge de la gestion de la page contact du site ainsi que toute personne légalement autorisée à accéder aux données. 
          La durée de traitement des données est limitée au temps pendant lequel vous êtes inscrit à nos services de communication, étant entendu que vous pouvez retirer votre consentement et vous désinscrire à tout moment en nous transmettant une demande par mail à l’adresse privacy@agrivitech.com.
          Le serveur sur lequel se trouve le site internet www.agrivitech.com est hébergé par AWS en France mais aucune information relative à vos données personnelles n’est transmise lors de votre inscription sur la page contact, lesquelles demeurent exclusivement dans le périmètre de la société AgriVitech. 
          Par ailleurs, vous disposez du droit de demander au responsable du traitement l’accès à vos données à caractère personnel, la rectification ou l’effacement de celles-ci, ou une limitation du traitement relatif à la personne concernée, ou du droit de s’opposer au traitement et du droit à la portabilité des données. Vous avez également le droit d’introduire une réclamation auprès d’une autorité de contrôle. 
        </div>

   </div>
</template>

<script >

import axios from'axios'


export default {
    name: 'contactDemo',
    data(){
      return {
        email: null,
        phone:null,
        name:null,
        content:null,
        result:null,
        hasError:false
      }
    },
    created(){

      if (this.$route.query.status === "conf"){
           this.sendSlack()
      }
    },
    methods: {
      sendSlack(){
        axios.post('https://discord.com/api/webhooks/1122785755010433055/si9x3PtsXp0MndS8sqYSEQQbk6Z9WPyEVfmXUpAfg_coLbC1YZ_S9b74pacb_1anEIga', {"content": "Nouvelle prise de rendez vous pour une démo"})
        this.hasError = false
        this.result = 'Votre demande de contact a bien été enregistrée'
      }
    }
    
}
</script>

<style lang="scss" scoped>

.formLabel{
    font-size: 20px;
    font-weight: 600;
}

.terms{
    font-size: 12px;
    color: grey;
    margin: 80px 0px;
    text-align: justify;
}
.result {
    font-weight: 600;
    margin-top: 10px;
    color: var(--mainGreen);
}

</style>